var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSectionExpand = function SvgSectionExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.284 20.284"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.156 5.071H9.128v4.057H5.071v2.028h4.057v4.057h2.028v-4.057h4.057V9.128h-4.057zM10.142 0a10.142 10.142 0 1 0 10.142 10.142A10.146 10.146 0 0 0 10.142 0m0 18.256a8.114 8.114 0 1 1 8.114-8.114 8.124 8.124 0 0 1-8.114 8.114"
  })));
};
export default SvgSectionExpand;